import React from 'react';
import { motion } from 'framer-motion';
import { ClipboardList, Dumbbell, Activity, Leaf, Users, MessageCircle, Brain } from 'lucide-react';

const pillars = [
  { icon: ClipboardList, title: 'Customized Programming', copy: 'Goals, schedule, ability, and equipment.' },
  { icon: Dumbbell, title: 'Strength', copy: 'Build muscle and physical capability.' },
  { icon: Activity, title: 'Athletic Movement', copy: 'Move well, not just look fit.' },
  { icon: Leaf, title: 'Nutrition Structure', copy: 'General habits and guidance you can sustain.' },
  { icon: Users, title: 'Accountability', copy: 'Progress checked. Adjustments made.' },
  { icon: MessageCircle, title: 'Direct Coaching', copy: 'Form, modifications, and support.' },
  { icon: Brain, title: 'Athlete Mindset', copy: 'Confidence, discipline, consistency.' },
];

export const TheMethod = () => {
  return (
    <section
      id="method"
      data-testid="the-method"
      className="bg-black py-14 sm:py-16 lg:py-20 px-6 border-b border-neutral-900"
    >
      <div className="container mx-auto max-w-7xl">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-40px' }}
          transition={{ duration: 0.7 }}
          className="grid lg:grid-cols-[1fr_2fr] gap-6 lg:gap-14 mb-10 lg:mb-14"
        >
          <div>
            <div className="flex items-baseline gap-4 mb-2">
              <span className="font-display text-gray-500 text-2xl">2.</span>
              <p className="text-gray-400 font-bold text-xs tracking-[0.35em] uppercase">
                The Coaching Method
              </p>
            </div>
            <p className="text-gray-400 uppercase text-xs tracking-[0.35em] mt-3">The Method</p>
            <h2 className="font-display text-white text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.95] mt-3">
              More Than <br />A Workout.
            </h2>
            <p className="text-gray-400 text-sm mt-5 max-w-md leading-relaxed">
              A complete coaching system built around your real life.
            </p>
          </div>
        </motion.div>

        {/* 7 pillars grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-4 sm:gap-5">
          {pillars.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-30px' }}
              transition={{ duration: 0.55, delay: i * 0.06 }}
              data-testid={`method-pillar-${i}`}
              className="rounded-xl border border-neutral-800 bg-neutral-950 p-4 sm:p-5 flex flex-col items-start hover:border-neutral-600 transition-colors"
            >
              <p.icon className="w-8 h-8 text-gray-300 mb-4" strokeWidth={1.4} />
              <h3 className="font-display text-white uppercase text-sm tracking-wide leading-tight">
                {p.title}
              </h3>
              <p className="text-gray-500 text-xs leading-relaxed mt-2">{p.copy}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
